import { Injectable, inject } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { IMenu } from '../models';
import { Repository } from '../database/repository';

@Injectable({
  providedIn: 'root',
})
export class MenuRepository extends Repository<IMenu, 'id'> {

  constructor() {
    const db = inject(NgxIndexedDBService);

    super(db, 'menus', 'id');
  }

}
